import { createPortal } from "react-dom";
import { usePortalTarget } from "./sidebarUtils";

const EmptyPortal = ({ slotId }) => {
  const portalTarget = usePortalTarget(slotId);

  const content = (
    <div className="flex flex-col gap-y-0.5">
      {/* Placeholder — items will be added here */}
    </div>
  );

  if (!portalTarget) return null;
  return createPortal(content, portalTarget);
};

export default EmptyPortal;
